import { useQuery } from '@tanstack/react-query'

import type { CollectiveAgreementSchema } from '../..'
import { queryClientOptions } from '../../../../provider'
import { type UseAppQueryOptions } from '../../../../types'
import {
  fetchOne,
  type FetchOneOption
} from '../account.collectiveAgreements.api'
import { accountCollectiveAgreementsCacheKeys } from '../account.collectiveAgreements.cacheKeys'

export const useFetchOne = (
  request: FetchOneOption,
  queryOptions?: UseAppQueryOptions<CollectiveAgreementSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: accountCollectiveAgreementsCacheKeys.fetch_one(request),
    queryFn: () => fetchOne(request),
    staleTime: queryClientOptions.time.STATIC,
    experimental_prefetchInRender: true
  })
}
